import { createGlobalStore } from 'hox';
import { useState } from 'react';

import config from '../../config';

interface GlobalConfig {
  isShowSideMenu?: SideMenuItem;
}

interface SideMenuItem {
  dashboard?: boolean;
  logs?: boolean;
  policy?: boolean;
  report?: boolean;
  quarantine?: boolean;
  administration?: boolean;
  visionOne?: boolean;
}
const sideMenuItem = config.ui.hideFeature.sideBar;
function useGlobalConfig() {
  const [globalConfig, setGlobalConfig] = useState<GlobalConfig>({
    isShowSideMenu: {
      dashboard: !sideMenuItem.dashboard,
      logs: !sideMenuItem.log,
      policy: !sideMenuItem.policy,
      report: !sideMenuItem.report,
      quarantine: !sideMenuItem.quarantine,
      administration: !sideMenuItem.administrator,
      visionOne: !sideMenuItem.visionOne,
    },
  });
  return {
    globalConfig,
    setGlobalConfig,
  };
}
export const [useGlobalConfigStore] = createGlobalStore(useGlobalConfig);
